import React from "react";
import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";

export default function Contacts() {
  return (
    <>
      <Header />
      <h1>ЗДЕСЬ БУДУТ КОНТАКТЫ</h1>
      <Footer />
    </>
  );
}
